// dialog4Reducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: '',
  lengthIndicator4Title: '',
  details: '',
  lengthIndicator4Details: '',
  noteBookmarkListItemToBeChanged: null,
  tab4AddChange: 1,
  buttonTextDialog4: '',
};

const dialog4Slice = createSlice({
  name: 'dialog4',
  initialState,
  reducers: {
    setButtonTextDialog4(state, action) {
      state.buttonTextDialog4 = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
    setLengthIndicator4Title(state, action) {
      state.lengthIndicator4Title = action.payload;
    },
    setDetails(state, action) {
      state.details = action.payload;
    },
    setLengthIndicator4Details(state, action) {
      state.lengthIndicator4Details = action.payload;
    },
    setTitleClearButton(state, action) {
      state.titleClearButton = action.payload;
    },
    setHistoryListItemSelected(state, action) {
      state.historyListItemSelected = action.payload;
    },
    setHistoryBookChapter(state, action) {
      state.historyBookChapter = action.payload;
    },
    setNoteBookmarkListItemToBeChanged(state, action) {
      state.noteBookmarkListItemToBeChanged = action.payload;
    },
    setTab4AddChange(state, action) {
      state.tab4AddChange = action.payload;
    },
    reset4Dialog4() {
      return initialState;
    },
  },
});

export const { setButtonTextDialog4, setTitle, setLengthIndicator4Title, setDetails, setLengthIndicator4Details, setTitleClearButton, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkListItemToBeChanged, setTab4AddChange, reset4Dialog4 } = dialog4Slice.actions;
export default dialog4Slice.reducer;
// const initialState = {
//   title: '',
//   lengthIndicator4Title: '',
//   details: '',
//   lengthIndicator4Details: '',
//   noteBookmarkListItemToBeChanged: null,
//   tab4AddChange: 1,
//   buttonTextDialog4: '',
// };

// export default function dialog4Reducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setButtonTextDialog4':
//       return {
//         ...state,
//         buttonTextDialog4: action.payload,
//       };
//     case 'setTitle':
//       return {
//         ...state,
//         title: action.payload,
//       };
//     case 'setLengthIndicator4Title':
//       return {
//         ...state,
//         lengthIndicator4Title: action.payload,
//       };      
//     case 'setDetails':
//       return {
//         ...state,
//         details: action.payload,
//       };      
//     case 'setLengthIndicator4Details':
//       return {
//         ...state,
//         lengthIndicator4Details: action.payload,
//       };           
//     case 'setTitleClearButton':
//       return {
//         ...state,
//         titleClearButton: action.payload,
//       };          
//     case 'setHistoryListItemSelected':
//       return {
//         ...state,
//         historyListItemSelected: action.payload,
//       };
//     case 'setHistoryBookChapter':
//       return {
//         ...state,
//         historyBookChapter: action.payload,
//       };
//     case 'setNoteBookmarkListItemToBeChanged':
//       return {
//         ...state,
//         noteBookmarkListItemToBeChanged: action.payload,
//       };      
//     case 'setTab4AddChange':
//       return {
//         ...state,
//         tab4AddChange: action.payload,
//       };      
//     case 'reset4Dialog4':
//       return initialState;          
//     default:
//       return state;
//   }
// }

// export const setButtonTextDialog4 = (e) => ({
//   type: 'setButtonTextDialog4',
//   payload: e,
// });

// export const setTitle = (e) => ({
//   type: 'setTitle',
//   payload: e,
// });

// export const setLengthIndicator4Title = (e) => ({
//   type: 'setLengthIndicator4Title',
//   payload: e,
// });

// export const setDetails = (e) => ({
//   type: 'setDetails',
//   payload: e,
// });

// export const setLengthIndicator4Details = (e) => ({
//   type: 'setLengthIndicator4Details',
//   payload: e,
// });

// export const setTitleClearButton = (e) => ({
//   type: 'setTitleClearButton',
//   payload: e,
// });

// export const setHistoryListItemSelected = (e) => ({
//   type: 'setHistoryListItemSelected',
//   payload: e,
// });

// export const setHistoryBookChapter = (e) => ({
//   type: 'setHistoryBookChapter',
//   payload: e,
// });

// export const setNoteBookmarkListItemToBeChanged = (e) => ({
//   type: 'setNoteBookmarkListItemToBeChanged',
//   payload: e,
// });

// export const setTab4AddChange = (e) => ({
//   type: 'setTab4AddChange',
//   payload: e,
// });

// export const reset4Dialog4  = (e) => ({
//   type: 'reset4Dialog4',
//   payload: e,
// });